import { toast } from "sonner"
import { X, XCircle } from "lucide-react"
import { hideErrorOverlay } from "@/shared/error-overlay"

type ToastType = "success" | "error" | "warning" | "info"

interface ToastCardProps {
  id: string | number
  type: ToastType
  message: string
}

export function ToastCard({ id, type, message }: ToastCardProps) {
  const isError = type === "error"

  function handleClose() {
    hideErrorOverlay()
    toast.dismiss(id)
  }

  return (
    <div className="flex flex-col w-full bg-background text-foreground border rounded-lg shadow-lg overflow-hidden">
      <div className="flex flex-col items-center px-4 py-3">
        {isError && (
          <XCircle
            className="size-12 text-[var(--danger-50,#e02424)] mb-2 -mt-1"
            strokeWidth={1.5}
          />
        )}
        <p
          className={`font-inter font-medium text-sm text-[var(--neutral-30)] flex-1${isError ? " text-center" : ""}`}
          style={isError ? { userSelect: "text", cursor: "text" } : undefined}
        >
          {message}
        </p>
      </div>
      {isError && (
        <div className="flex items-center justify-center gap-2 border-t border-[var(--brand-90)] px-4 py-2">
          <button
            onClick={handleClose}
            className="inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium bg-[var(--brand-50)] text-primary-foreground hover:bg-[var(--brand-40)] transition-colors"
          >
            <X className="size-3" />
            Kapat
          </button>
        </div>
      )}
    </div>
  )
}
